import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccountStatusError = ({ error, message, reason, bannedAt, suspendedAt, appealEmail, appealSubject }) => {
  const navigate = useNavigate();

  const handleAppeal = () => {
    const subject = encodeURIComponent(appealSubject || 'Account Appeal');
    const body = encodeURIComponent(
      `Hello,\n\nI would like to appeal my account status.\n\n` +
      `Account Status: ${error}\n` +
      `Reason: ${reason || 'No reason provided'}\n` +
      `Date: ${bannedAt || suspendedAt || 'Unknown'}\n\n` +
      `Please review my account and let me know if you need any additional information.\n\n` +
      `Thank you.`
    );
    
    window.open(`mailto:${appealEmail}?subject=${subject}&body=${body}`, '_blank');
  };

  const handleLogout = () => {
    // Clear any stored tokens
    localStorage.removeItem('token');
    sessionStorage.clear();
    // Redirect to login
    navigate('/login');
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f3f4f6', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: '16px' 
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '400px', 
        margin: '0 auto' 
      }}>
        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '12px', 
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', 
          padding: '32px', 
          textAlign: 'center' 
        }}>
          {/* Warning Icon */}
          <div style={{ 
            margin: '0 auto 16px', 
            height: '48px', 
            width: '48px', 
            color: '#ef4444' 
          }}>
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ width: '100%', height: '100%' }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>

          {/* Title */}
          <h1 style={{ 
            fontSize: '20px', 
            fontWeight: 'bold', 
            color: '#111827', 
            marginBottom: '8px',
            margin: '0 0 8px 0'
          }}>
            {error === 'Account banned' ? 'Account Banned' : 'Account Suspended'}
          </h1>
          
          {/* Message */}
          <p style={{ 
            fontSize: '14px', 
            color: '#6b7280', 
            marginBottom: '24px',
            lineHeight: '1.5',
            margin: '0 0 24px 0'
          }}>
            {message}
          </p>

          {/* Details Card */}
          <div style={{ 
            backgroundColor: '#f9fafb', 
            borderRadius: '8px', 
            padding: '16px', 
            marginBottom: '24px', 
            textAlign: 'left' 
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <span style={{ 
                  fontSize: '12px', 
                  fontWeight: '500', 
                  color: '#6b7280', 
                  textTransform: 'uppercase', 
                  letterSpacing: '0.05em' 
                }}>
                  Reason
                </span>
                <p style={{ 
                  fontSize: '14px', 
                  color: '#111827', 
                  marginTop: '4px', 
                  fontWeight: '500',
                  margin: '4px 0 0 0'
                }}>
                  {reason || 'No reason provided'}
                </p>
              </div>
              
              {(bannedAt || suspendedAt) && (
                <div>
                  <span style={{ 
                    fontSize: '12px', 
                    fontWeight: '500', 
                    color: '#6b7280', 
                    textTransform: 'uppercase', 
                    letterSpacing: '0.05em' 
                  }}>
                    Date
                  </span>
                  <p style={{ 
                    fontSize: '14px', 
                    color: '#111827', 
                    marginTop: '4px',
                    margin: '4px 0 0 0'
                  }}>
                    {new Date(bannedAt || suspendedAt).toLocaleDateString()}
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <button
              onClick={handleAppeal}
              style={{ 
                width: '100%', 
                padding: '10px 16px', 
                backgroundColor: '#2563eb', 
                color: 'white', 
                fontSize: '14px', 
                fontWeight: '500', 
                borderRadius: '8px', 
                border: 'none',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
            >
              Appeal Account
            </button>
            <button
              onClick={handleLogout}
              style={{ 
                width: '100%', 
                padding: '10px 16px', 
                border: '1px solid #d1d5db', 
                color: '#374151', 
                fontSize: '14px', 
                fontWeight: '500', 
                borderRadius: '8px', 
                backgroundColor: 'white',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#f9fafb'}
              onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountStatusError;